module.exports = __webpack_public_path__ + "static/img/brand-09.ceea0ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand-09.png
// module id = 1TaF
// module chunks = 1